var moduleMap = {
	"./store": () => {
		return Promise.all([__webpack_require__.e(9507), __webpack_require__.e(367), __webpack_require__.e(8206)]).then(() => (() => ((__webpack_require__(78206)))));
	},
	"./CommentsAndAttachment": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(9507), __webpack_require__.e(792), __webpack_require__.e(367), __webpack_require__.e(2563), __webpack_require__.e(455), __webpack_require__.e(8611), __webpack_require__.e(8909), __webpack_require__.e(4141), __webpack_require__.e(2189), __webpack_require__.e(6620)]).then(() => (() => ((__webpack_require__(76620)))));
	},
	"./History": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(9507), __webpack_require__.e(792), __webpack_require__.e(367), __webpack_require__.e(2563), __webpack_require__.e(455), __webpack_require__.e(8611), __webpack_require__.e(8909), __webpack_require__.e(4141), __webpack_require__.e(2189), __webpack_require__.e(3442)]).then(() => (() => ((__webpack_require__(13442)))));
	},
	"./postAppheaderSection": () => {
		return Promise.all([__webpack_require__.e(5857), __webpack_require__.e(318), __webpack_require__.e(9507), __webpack_require__.e(792), __webpack_require__.e(2563), __webpack_require__.e(4141), __webpack_require__.e(4685)]).then(() => (() => ((__webpack_require__(15695)))));
	},
	"./decryptionServiceInstance": () => {
		return Promise.all([__webpack_require__.e(455), __webpack_require__.e(5202)]).then(() => (() => ((__webpack_require__(5202)))));
	},
	"./configKeyService": () => {
		return Promise.all([__webpack_require__.e(9507), __webpack_require__.e(792)]).then(() => (() => ((__webpack_require__(70792)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});